import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {NgClass} from '@angular/common';
import {HashMap, TranslocoPipe} from '@jsverse/transloco';
import {RfiCoverageBarComponent} from '../../rfi-coverage-bar/rfi-coverage-bar.component';

@Component({
  selector: 'app-coverage-kpi-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, TranslocoPipe, RfiCoverageBarComponent],
  templateUrl: './coverage-kpi-card.component.html',
})
export class CoverageKpiCardComponent {
  readonly labelKey = input.required<string>();
  readonly value = input.required<string | number>();
  readonly valueClass = input('');
  readonly noteKey = input('');
  readonly noteParams = input<HashMap>({});
  readonly barPercent = input<number | null>(null);

  protected readonly hasBar = computed(() => this.barPercent() !== null);
}
